export default __webpack_public_path__ + "static/media/account_circle.266ba5c9.svg";